/* eslint-disable react/jsx-curly-newline */
import '@resources/fontes/fontes.css'
import '@resources/css/cardsample/cardsample.css'
import React, { useContext } from 'react'
import { Card } from 'react-bootstrap'
import Photo from '@resources/imgs/mask-group-2.png'
import LogoProssed from '@resources/imgs/logo-proseed.webp'
import { Link } from 'react-router-dom'
import New from '@resources/imgs/icon-new.svg'
import LogoEuropean from '@resources/imgs/european.webp'
import LogoSeattle from '@resources/imgs/seattle.png'
import Ovulos from '@resources/imgs/tratament-2.png'
import Embriao from '@resources/imgs/tratament-1.png'
import Trompas from '@resources/imgs/tratament-3.png'
import IDonor from '@interfaces/IDonor'
import { FaHeart, FaHeartBroken, FaCheck } from 'react-icons/fa'
import { TbBabyCarriage } from 'react-icons/tb'
import { displayOnProduction } from '@helpers/Utils'
import AuthContext from '@contexts/Auth'

interface CardSampleProps {
  donor: IDonor
  selectedTreatment?: string
  handleUnfavorite?: (id: string) => void
  handleAddToCart?: (id: string) => void
  cartDonorIds?: string[]
  addingToCart?: string[]
}
const CardSample: React.FC<CardSampleProps> = ({ donor, selectedTreatment, handleUnfavorite, handleAddToCart, cartDonorIds = [], addingToCart = [] }) => {
  const { activeInProgressOrders } = useContext(AuthContext)

  const [isHovered, setIsHovered] = React.useState(false)
  const availableTreatments = donor?.available_treatment_names ?? []
  const isTreatmentEligible = !selectedTreatment || availableTreatments.includes(selectedTreatment === 'Inseminação' ? 'IIU' : selectedTreatment)
  const isNational = donor?.sperm_bank?.name === 'Pro-Seed'
  const isInCart = cartDonorIds.includes(String(donor?.internal_id))

  const treatments = [
    {
      key: 'ICSI',
      label: 'ICSI',
      icon: Ovulos,
      price: donor.icsi_price,
    },
    {
      key: 'FIV',
      label: 'FIV',
      icon: Embriao,
      price: donor.fiv_price,
    },
    {
      key: 'IIU',
      label: 'Inseminação',
      icon: Trompas,
      price: donor.iiu_price,
    },
  ]

  const renderSpermBankLogo = () => {
    if (donor?.sperm_bank?.name === 'Pro-Seed') return <img src={LogoProssed} alt="Pro-Seed" />
    if (donor?.sperm_bank?.name === 'European Sperm Bank') return <img src={LogoEuropean} alt="European Sperm Bank" />
    if (donor?.sperm_bank?.name === 'Seattle Sperm Bank') return <img src={LogoSeattle} alt="Seattle Sperm Bank" />

    return <img src={LogoProssed} alt="Banco de sêmen" />
  }

  return (
    <div className="card-sample box-card p-2 mb-4">
      <Card className={`donator-card ${isTreatmentEligible ? 'border-none' : 'border-red'}`}>
        <Card.Body className="card-body-donator">

          <div className="d-flex flex-column gap-10 w-100">
            {handleUnfavorite && (
              <button
                className="card-remove"
                onClick={() => handleUnfavorite?.(String(donor.internal_id))}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                {isHovered ? <FaHeartBroken /> : <FaHeart />}
              </button>
            )}

            <div className="d-flex justify-content-start align-items-start gap-10 mb-2">
              <div className="img-user">
                <figure className="d-flex justify-content-center">
                  <img src={donor.avatar || Photo} alt="" />
                  {donor?.is_new_donor ? (
                    <figcaption className="">
                      <div className="icon-new">
                        <img src={New} alt="" />
                      </div>
                    </figcaption>
                  ) : null}
                </figure>
              </div>

              <div className="h-100 d-flex flex-column gap-5 w-100">
                <Link to={`/doadores/${String(donor.internal_id).toLowerCase()}`} target="_blank" className="donor-id">
                  ID: {donor.internal_id}
                </Link>

                <span className={`donor-origin ${isNational ? 'donor-origin--national' : 'donor-origin--international'}`}>
                  {isNational ? 'Nacional' : 'Importado'}
                </span>

                {(donor.donor_type || donor.nickname) && (
                  <span className="donor-nickname">
                    {donor.donor_type && donor.nickname
                      ? `${donor.nickname} - ${donor.donor_type}`
                      : donor.donor_type || donor.nickname
                    }
                  </span>
                )}

                <div className="donor-bank" aria-hidden={!donor?.sperm_bank?.name}>
                  {renderSpermBankLogo()}
                </div>
              </div>
            </div>

            {selectedTreatment && (
              <p className="not-eligible">{!isTreatmentEligible ? 'Doador incompatível' : ' '}</p>
            )}
          </div>

          <div className="d-flex flex-column gap-10 w-100">
            <div className="treatments w-100">
              <div className="treatment-grid">
                {treatments.map((treatment) => {
                  const isAvailable = availableTreatments.includes(treatment.key)
                  const price = treatment.price ? `R$ ${treatment.price}` : 'Sem Valor'

                  return (
                    <div key={treatment.key} className={`treatment-tile ${isAvailable ? 'treatment-tile--available' : 'treatment-tile--disabled'}`}>
                      <div className="treatment-tile__icon">
                        <img src={treatment.icon} alt={treatment.label} />
                      </div>
                      <span className="treatment-tile__label">{treatment.label}</span>
                      <span className="treatment-tile__price">{isAvailable ? price : 'Indisponível'}</span>
                    </div>
                  )
                })}
              </div>
            </div>

            {displayOnProduction() && handleAddToCart && activeInProgressOrders.length < 1 && (
              <button
                className={`add-cart-btn ${isInCart || !donor?.is_display_active || availableTreatments.length === 0 ? 'in-cart' : ''}`}
                onClick={() => !isInCart && !addingToCart.includes(String(donor.internal_id)) && handleAddToCart?.(String(donor.internal_id))}
                disabled={isInCart || addingToCart.includes(String(donor.internal_id)) || !donor?.is_display_active || availableTreatments.length === 0}
              >
                {isInCart ? (
                  <>
                    <FaCheck className="cart-icon"/>
                    Já no carrinho
                  </>
                ) : addingToCart.includes(String(donor.internal_id)) ? (
                  <>
                    <div className="spinner-border spinner-border-sm cart-icon" role="status"></div>
                    Adicionando...
                  </>
                ) : (donor?.is_display_active && availableTreatments.length > 0) ? (
                  <>
                    <TbBabyCarriage className="cart-icon"/>
                    Adicionar ao carrinho
                  </>
                ) : (
                  <>
                    <TbBabyCarriage className="cart-icon"/>
                    Doador Indisponível
                  </>
                )}
              </button>
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default CardSample
